import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { CereriService } from 'src/app/components/cereri/cereri.service';
// import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { environment } from 'src/environments/environment';
import { Observable, Subject, catchError, distinctUntilChanged, finalize, map, of, switchMap, takeUntil, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialog.service';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { Generic, GenericStatusCerere } from 'src/app/interfaces/generic.interface';
import { DataTableDirective } from 'angular-datatables';
import { helper } from 'src/environments/helper';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import * as $ from 'jquery';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { ICerere, ICerereListDT } from './cereri.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppFilesService } from 'src/app/services/app-files.service';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2';
import { RegistreService } from 'src/app/platform/nomenclatoare/registre/registre.service';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { CereriAsigneazaComponent } from './cereri-asigneaza/cereri-asigneaza.component';
import { CereriStatusComponent } from './cereri-status/cereri-status.component';
import { UserOrganigramaSearchPayload } from 'src/app/interfaces/common.interface';
import { UsersService } from 'src/app/services/users.service';
import { GestiuneAjutoareService } from '../gestiune-ajutoare/gestiune-ajutoare.service';
import { CereriAlocaVerificatorComponent } from './cereri-aloca-verificator/cereri-aloca-verificator.component';
import { StatItem, StatKey } from './ajutoare-stats-bar/ajutoare-stats.types';
import { S } from '@angular/cdk/keycodes';

@Component({
    selector: 'app-cereri',
    templateUrl: './cereri.component.html',
    styleUrls: ['./cereri.component.scss'],
})
export class CereriComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;
    editorConfig!: AngularEditorConfig;
    isLoading = false;
    isFilterLoading = false;
    showCard = false;
    checkboxSelections = false;
    selectedAddressType = '-1';
    judete!: Generic[];
    dgaspc_id = environment.interop.dgaspcId;

    selectedFiltre = 'simple';

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';

    // Last day of the current year
    lastDayOfYear: Date = new Date(new Date().getFullYear(), 11, 31);
    lastDayOfNextYear: Date = new Date(new Date().getFullYear() + 1, 11, 31);

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setToday(): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `today`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = yearsBack === 0 ? this.today : new Date(year, 11, 31);
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    setTodayToEndYear(): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        this.selectedEndDate = this.lastDayOfYear;
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.rerenderDT();
        this.selectedFilteringButton = 'today_to_end_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    // Date popover filtering

    dateFilteringOptions: { id: number; value: string }[] = [
        { id: 1, value: 'Adăugare' },
        { id: 2, value: 'Actualizare' },
        { id: 3, value: 'Validare' },
        { id: 4, value: 'Invalidare/Anulare' },
        { id: 5, value: 'Finalizare' },
    ];

    dateFilterOption: number = 1;

    statusParametersValue!: string;
    categoryParametersValue!: string;
    notificationParameter: { id: string; name: string } = { id: '-1', name: '' };

    // Values for status filtering

    defaultParameter: { name: string; id: number } = {
        name: 'Toate',
        id: -1,
    };

    filterParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    validationParameters: { name: string; id: number }[] = [
        { name: 'Toate', id: -1 },
        { name: 'Validată', id: 1 },
        { name: 'Invalidată', id: 2 },
        { name: 'Anulată', id: 3 },
        { name: 'Necesită atenție', id: 4 },
    ];

    // Vaue for status filtering
    selectedStatusID: number = this.defaultParameter.id;

    // Values for category filtering
    categoryToggleOptions = [
        { id: -1, value: 'Toate' },
        { id: 1, value: 'De aprobat' },
        { id: 2, value: 'Departamentele mele' },
        { id: 3, value: 'Cererile mele' },
        { id: 4, value: 'Mesaje interne' },
    ];

    selectedCategory: string | number = this.categoryToggleOptions[0].id;
    private defaultCategory: string | number = -1;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    statusuriCerere!: GenericStatusCerere[];

    directii: Generic[] = [];
    filteredDirectii: Generic[] = [];
    directiiControl = new FormControl();

    compartimente: Generic[] = [];
    filteredCompartimente: Generic[] = [];
    compartimenteControl = new FormControl();

    tipCerere: Generic[] = [];
    filteredTipCerere: any[] = [];
    tipCerereControl = new FormControl();

    registre!: Generic[];

    directiiResponsabil: Generic[] = [];
    filteredDirectiiResponsabil: Generic[] = [];
    directiiResponsabilControl = new FormControl();

    compartimenteResponsabil!: Generic[];
    filteredCompartimenteResponsabil: any[] = [];
    compartimenteResponsabilControl = new FormControl();

    operatori: Generic[] = [];
    filteredOperatori: any[] = [];
    operatoriControl = new FormControl();

    // Pre-validare typeahead
    pvUsers: any[] = [];
    filteredPvResponsabili: any[] = [];
    filteredPvAnaf: any[] = [];
    pvResponsabilControl = new FormControl();
    pvAnafControl = new FormControl();

    // My counters widget
    myCounters: any = null;
    activeCounterFilter = '';
    ajutoareStats: StatItem[] = [];
    statsLastUpdated?: Date;

    // Assignment filter properties
    assignmentFunctii: Generic[] = [];
    filteredAssignmentFunctii: Generic[] = [];
    assignmentFunctiiControl = new FormControl();

    assignmentDirectii: Generic[] = [];
    filteredAssignmentDirectii: Generic[] = [];
    assignmentDirectiiControl = new FormControl();

    assignmentCompartimente: Generic[] = [];
    filteredAssignmentCompartimente: Generic[] = [];
    assignmentCompartimenteControl = new FormControl();

    assignmentOperatori: Generic[] = [];
    filteredAssignmentOperatori: Generic[] = [];
    assignmentOperatoriControl = new FormControl();

    parameters: { key: string; value: string }[] = [
        { key: '-- Alegeți --', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    address_type: { key: string; value: string }[] = [
        { key: '-- Alegeți --', value: '-1' },
        { key: 'Domiciliu/Reședință', value: '1' },
        { key: 'Sediu', value: '2' },
        { key: 'Beneficiar', value: '3' },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    private destroy$ = new Subject<void>();

    activeFilters = 0;
    searchParamsForm!: FormGroup;

    filterCount: number = 0;

    //Form Initial Values
    initialFormValues = {
        numarCerere: null,
        numarCerereIntern: null,
        cnp_cui: null,
        cetatean_pj: '',
        telefon: null,
        email: '',
        check_adresa_proprietate: false,
        numar_cadastral: null,
        proprietate_strada: '',
        proprietate_numar: '',
        proprietate_scara: '',
        proprietate_bloc: '',
        proprietate_etaj: '',
        proprietate_apartament: '',
        proprietate_observatii: '',
        tip_adresa: -1,
        judet: -1,
        city: '',
        streetName: '',
        streetNumber: '',
        directie: this.dgaspc_id,
        compartimentValue: '-1',
        cerere_types: '-1',
        registru_types: -1,
        numarRegistru: null,
        directieResponsabil: this.dgaspc_id,
        compartimentResponsabil: '-1',
        operator: '',
        status_validat: '-1',
        status_invalidat: '-1',
        status_clasat: '-1',
        status_finalizat: '-1',
        assignmentFunctie: '-1',
        assignmentDirectie: '-1',
        assignmentCompartiment: '-1',
        assignmentOperator: '',
        etapa_nr: null,
        etapa_status: null,
        etapa_docs_status: null,
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            numarCerere: new FormControl(null),
            numarCerereIntern: new FormControl(null),
            cnp_cui: new FormControl(null),
            cetatean_pj: new FormControl(''),
            telefon: new FormControl(null),
            email: new FormControl(''),
            check_adresa_proprietate: new FormControl(false),
            numar_cadastral: new FormControl(null),
            proprietate_strada: new FormControl(''),
            proprietate_numar: new FormControl(''),
            proprietate_scara: new FormControl(''),
            proprietate_bloc: new FormControl(''),
            proprietate_etaj: new FormControl(''),
            proprietate_apartament: new FormControl(''),
            proprietate_observatii: new FormControl(''),
            tip_adresa: new FormControl(-1),
            judet: new FormControl(-1),
            city: new FormControl(''),
            streetName: new FormControl(''),
            streetNumber: new FormControl(''),
            directie: new FormControl(this.dgaspc_id),
            compartimentValue: new FormControl('-1'),
            cerere_types: new FormControl('-1'),
            registru_types: new FormControl(-1),
            numarRegistru: new FormControl(null),
            directieResponsabil: new FormControl(this.dgaspc_id),
            compartimentResponsabil: new FormControl('-1'),
            operator: new FormControl(''),
            status_validat: new FormControl('-1'),
            status_invalidat: new FormControl('-1'),
            status_clasat: new FormControl('-1'),
            status_finalizat: new FormControl('-1'),
            assignmentFunctie: new FormControl('-1'),
            assignmentDirectie: new FormControl('-1'),
            assignmentCompartiment: new FormControl('-1'),
            assignmentOperator: new FormControl(''),
            etapa_nr: new FormControl(null),
            etapa_status: new FormControl(null),
            etapa_docs_status: new FormControl(null),
            pre_validare_status: new FormControl(null),
            pre_validare_responsabil_id: new FormControl(null),
            pre_validare_anaf_user_id: new FormControl(null),
        });
    }

    checkActiveFilters() {
        this.activeFilters = 0;
        const currentFilters = this.searchParamsForm.value;

        for (const [key, value] of Object.entries(this.initialFormValues)) {
            if (key in currentFilters && currentFilters[key] !== value) {
                this.activeFilters++
            }
        }
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.activeFilters = 0;
        this.selectedCategory = this.defaultCategory;

        this.resetFieldsSearch();

        this.selectedAddressType = '-1';
        this.rerenderDT();
        this.showCard = true;
    }

    resetFieldsSearch() {
        this.loadCompartimente(this.dgaspc_id);
        this.loadCompartimenteResponsabil(this.dgaspc_id);

        this.filteredDirectii = this.directii;
        this.directiiControl.setValue(null);
        this.compartimenteControl.setValue(null);
        this.tipCerereControl.setValue(null);
        this.tipCerere = [];
        this.filteredTipCerere = [];

        this.filteredDirectiiResponsabil = this.directii;
        this.directiiResponsabilControl.setValue(null);
        this.compartimenteResponsabilControl.setValue(null);
        this.operatoriControl.setValue(null);
        this.operatori = [];
        this.filteredOperatori = [];

        // Reset assignment filters
        this.filteredAssignmentFunctii = this.assignmentFunctii;
        this.assignmentFunctiiControl.setValue(null);

        this.filteredAssignmentDirectii = this.assignmentDirectii;
        this.assignmentDirectiiControl.setValue(null);

        this.assignmentCompartimenteControl.setValue(null);
        this.assignmentCompartimente = [];
        this.filteredAssignmentCompartimente = [];

        this.assignmentOperatoriControl.setValue(null);
        this.assignmentOperatori = [];
        this.filteredAssignmentOperatori = [];

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch()
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT(true);
        this.checkActiveFilters();
    }

    selectedRowIds: number[] = [];

    rowCount = 0;

    dtLink =
        environment.interop.basePath +
        environment.interop.dgaspc.cerere.getCereriListDT;

    notificationServiceBefore: any = {
        currentStatus: -1,
        currentCategory: -1,
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private cereriService: CereriService,
        private registreService: RegistreService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService,
        public commonService: CommonService,
        private router: Router,
        private route: ActivatedRoute,
        private appFileService: AppFilesService,
        private usersService: UsersService,
        private gestiuneService: GestiuneAjutoareService,
    ) {
        this.tomorrow.setDate(this.today.getDate() + 1);
    }

    ngOnInit(): void {
        this.renderDT();
        this.loadCerereStatuses();
        this.loadRegistre();
        this.loadJudete();

        this.loadDirectiiActive();
        this.loadCompartimente(this.dgaspc_id);
        this.loadCompartimenteResponsabil(this.dgaspc_id);
        this.loadAssignmentFunctii();
        this.loadAssignmentDirectii();

        this.editorConfig = initializeEditor();
        this.buildSearchParamsForm();
        this.redirectFromNotifications();
        this.filterCategoryOptions();

        this.renderFieldsSearch();
        this.loadOperatori();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
        this.loadPvUsers();
        this.loadMyCounters();
        this.applyNumarCerereFromUrl();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();

        this.destroy$.next();
        this.destroy$.complete();
    }

    applyNumarCerereFromUrl() {
        const numarCerere = this.route.snapshot.queryParamMap.get('numarCerere');
        if (numarCerere) {
            this.searchParamsForm.get('numarCerere')?.setValue(numarCerere);
            this.applyFilters();
        }
    }

    redirectFromNotifications() {
        this.notificationService.currentNotification.subscribe(
            (notification: { id: string; name: string }) => {
                if (notification) {
                    this.notificationParameter = notification;
                    // here we need to update our buttons
                    this.notificationServiceBefore.currentStatus = this.selectedStatusID;
                    this.notificationServiceBefore.currentCategory = this.selectedCategory;

                    this.selectedStatusID = -1;
                    this.selectedCategory = -1;

                    this.rerenderDT();
                }
            }
        );
    }

    removeChip(): void {
        // Resets the notification parameter which we send to our backend with -1 so the filter for this particular flag is canceled
        this.notificationParameter = { id: '-1', name: '' };

        // here we need to update our buttons
        this.selectedStatusID = this.notificationServiceBefore.currentStatus;
        this.selectedCategory = this.notificationServiceBefore.currentCategory;

        this.rerenderDT();
    }

    loadCerereStatuses() {
        this.isFilterLoading = true;
        this.commonService
            .getCerereStatusesActive()
            .pipe(
                map((results: any) => [...results, this.defaultParameter]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusuriCerere = results;
                },
                error: (error) => {
                    console.error('Error loading request statuses', error);
                    this.isFilterLoading = false;
                },
            });
    }

    loadRegistre() {
        this.isFilterLoading = true;
        this.registreService
            .getRegistre()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.registre = results;
                },
                error: (error) => {
                    console.error('Error loading registre', error);
                    this.isFilterLoading = false;
                }
            })
    }

    renderFieldsSearch() {
        this.directiiControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredDirectii = this.directii;
                    return of(this.directii);
                }
                return this.filterDirectii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectii = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.compartimenteControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCompartimente = this.compartimente;
                    return of(this.compartimente);
                }
                return this.filterCompartimente(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCompartimente = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.tipCerereControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredTipCerere = this.tipCerere;
                    return of(this.tipCerere);
                }
                return this.filterTipCerere(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTipCerere = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.directiiResponsabilControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredDirectiiResponsabil = this.directiiResponsabil;
                    return of(this.directiiResponsabil);
                }
                return this.filterDirectiiResponsabil(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiResponsabil = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.compartimenteResponsabilControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCompartimenteResponsabil = this.compartimenteResponsabil;
                    return of(this.compartimenteResponsabil);
                }
                return this.filterCompartimenteResponsabil(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCompartimenteResponsabil = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredOperatori = this.operatori;
                    return of(this.operatori);
                }
                return this.filterOperatori(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatori = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        // Pre-validare typeahead search
        this.pvResponsabilControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (!inputValue || inputValue.length < 1) {
                    this.filteredPvResponsabili = this.pvUsers;
                    return of(this.pvUsers);
                }
                const norm = this.normalizeString(inputValue);
                return of(this.pvUsers.filter(u => this.normalizeString(u.name).includes(norm)));
            }),
            tap((data: any[]) => { this.filteredPvResponsabili = data; }),
            catchError(() => of([]))
        ).subscribe();

        this.pvAnafControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (!inputValue || inputValue.length < 1) {
                    this.filteredPvAnaf = this.pvUsers;
                    return of(this.pvUsers);
                }
                const norm = this.normalizeString(inputValue);
                return of(this.pvUsers.filter(u => this.normalizeString(u.name).includes(norm)));
            }),
            tap((data: any[]) => { this.filteredPvAnaf = data; }),
            catchError(() => of([]))
        ).subscribe();

        // Assignment filter search functionality
        this.assignmentFunctiiControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredAssignmentFunctii = this.assignmentFunctii;
                    return of(this.assignmentFunctii);
                }
                return this.filterAssignmentFunctii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredAssignmentFunctii = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.assignmentDirectiiControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredAssignmentDirectii = this.assignmentDirectii;
                    return of(this.assignmentDirectii);
                }
                return this.filterAssignmentDirectii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredAssignmentDirectii = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.assignmentCompartimenteControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredAssignmentCompartimente = this.assignmentCompartimente;
                    return of(this.assignmentCompartimente);
                }
                return this.filterAssignmentCompartimente(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredAssignmentCompartimente = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.assignmentOperatoriControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredAssignmentOperatori = this.assignmentOperatori;
                    return of(this.assignmentOperatori);
                }
                return this.filterAssignmentOperatori(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredAssignmentOperatori = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    loadDirectiiActive() {
        this.isFilterLoading = true;
        this.commonService
            .getDirectiiActive()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isFilterLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.directii = results;
                    this.directiiResponsabil = results;

                    this.filteredDirectii = [...this.directii];
                    this.filteredDirectiiResponsabil = [...this.directiiResponsabil];
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.filteredDirectii = [];
                    this.filteredDirectiiResponsabil = [];
                },
            });
    }

    onDirectiiClosed() {
        const selectedValue = this.directiiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredDirectii.some(directie =>
                directie.id === this.searchParamsForm.get('directie')?.value
            );

            if (!isSelectedInFilteredList) {
                this.directiiControl.setValue(null);
                this.filteredDirectii = this.directii;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onDirectiiChange(directieId: number): void {
        this.searchParamsForm.controls['compartimentValue'].patchValue('-1');
        this.searchParamsForm.controls['cerere_types'].patchValue('-1');

        if (directieId > 0) {
            this.loadCompartimente(directieId);
        } else {
            this.compartimente = [];
            this.tipCerere = [];
            this.filteredCompartimente = [];
            this.filteredTipCerere = [];
        }
    }

    loadCompartimente(directieId?: number) {
        this.isFilterLoading = true;

        let compartimenteObservable$ = directieId
            ? this.commonService.getCompartimenteByDirectieId(directieId)
            : this.commonService.getCompartimenteActive();

        compartimenteObservable$
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            )
            .subscribe({
                next: (data) => {
                    this.compartimente = [...data];
                    this.filteredCompartimente = [...this.compartimente];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredCompartimente = [];
                },
            });
    }

    onCompartimenteClosed() {
        const selectedValue = this.compartimenteControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCompartimente.some(compartiment =>
                compartiment.id === this.searchParamsForm.get('compartimentValue')?.value
            );

            if (!isSelectedInFilteredList) {
                this.compartimenteControl.setValue(null);
                this.filteredCompartimente = this.compartimente;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onCompartimenteChange(compartimentId: number): void {
        this.searchParamsForm.controls['cerere_types'].patchValue('-1');

        if (compartimentId > 0) {
            this.loadCerereTypes(compartimentId);
        } else {
            this.tipCerere = [];
            this.filteredTipCerere = [];
        }
    }

    loadCerereTypes(compartimentId: number) {
        this.isFilterLoading = true;
        this.commonService
            .getCerereTypesByComp(compartimentId)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            ).subscribe({
                next: (data) => {
                    this.tipCerere = [...data];
                    this.filteredTipCerere = [...this.tipCerere];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredTipCerere = [];
                },
            });
    }

    onCerereTypesClosed() {
        const selectedValue = this.tipCerereControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredTipCerere.some(cerere =>
                cerere.id === this.searchParamsForm.get('cerere_types')?.value
            );

            if (!isSelectedInFilteredList) {
                this.tipCerereControl.setValue(null);
                this.filteredTipCerere = this.tipCerere;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onDirectiiResponsabilChange(directieId: number): void {
        this.searchParamsForm.controls['compartimentResponsabil'].patchValue('-1');
        this.searchParamsForm.controls['operator'].patchValue('');

        if (directieId > 0) {
            this.loadCompartimenteResponsabil(directieId);
            this.loadOperatori();
        } else {
            this.compartimenteResponsabil = [];
            this.operatori = [];
            this.filteredCompartimenteResponsabil = [];
            this.filteredOperatori = [];
        }
    }

    onDirectiiResponsabilClosed() {
        const selectedValue = this.directiiResponsabilControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredDirectiiResponsabil.some(directie =>
                directie.id === this.searchParamsForm.get('directieResponsabil')?.value
            );

            if (!isSelectedInFilteredList) {
                this.directiiResponsabilControl.setValue(null);
                this.filteredDirectiiResponsabil = this.directiiResponsabil;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    loadCompartimenteResponsabil(directieId?: number) {
        this.isFilterLoading = true;

        let compartimenteObservable$ = directieId
            ? this.commonService.getCompartimenteByDirectieId(directieId)
            : this.commonService.getCompartimenteActive();

        compartimenteObservable$
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            )
            .subscribe({
                next: (data) => {
                    this.compartimenteResponsabil = [...data];
                    this.filteredCompartimenteResponsabil = [...this.compartimenteResponsabil];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredCompartimenteResponsabil = [];
                },
            });
    }

    onCompartimenteResponsabilClosed() {
        const selectedValue = this.compartimenteResponsabilControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCompartimenteResponsabil.some(compartiment =>
                compartiment.id === this.searchParamsForm.get('compartimentResponsabil')?.value
            );

            if (!isSelectedInFilteredList) {
                this.compartimenteResponsabilControl.setValue(null);
                this.filteredCompartimenteResponsabil = this.compartimenteResponsabil;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onCompartimenteResponsabilChange(compartimentId: number): void {
        this.searchParamsForm.controls['operator'].patchValue('');
        console.log('CALLED COMPARIMENTE CHANGE');
        if (compartimentId) {
            this.loadOperatori();
        } else {
            this.operatori = [];
            this.filteredOperatori = [];
        }
    }

    loadOperatori() {
        this.isFilterLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.searchParamsForm.controls['directieResponsabil'].value,
            compartiment_id: this.searchParamsForm.controls['compartimentResponsabil'].value !== '-1' ? this.searchParamsForm.controls['compartimentResponsabil'].value : null
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatori = [...data];
                    this.filteredOperatori = [...this.operatori];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatori = [];
                },
            });
    }

    onOperatorClosed() {
        const selectedValue = this.operatoriControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredOperatori.some(operator =>
                operator.id === this.searchParamsForm.get('operator')?.value
            );

            if (!isSelectedInFilteredList) {
                this.operatoriControl.setValue(null);
                this.filteredOperatori = this.operatori;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    // Pre-validare typeahead
    loadPvUsers(): void {
        this.usersService.getUsersActive().subscribe({
            next: (res: any) => {
                const data = (res?.data || res || []).map((u: any) => ({ id: u.id_user || u.id, name: u.name }));
                this.pvUsers = data;
                this.filteredPvResponsabili = [...data];
                this.filteredPvAnaf = [...data];
            },
            error: () => { this.filteredPvResponsabili = []; this.filteredPvAnaf = []; },
        });
    }

    onPvResponsabilClosed(): void {
        this.pvResponsabilControl.setValue(null);
        this.filteredPvResponsabili = [...this.pvUsers];
    }

    onPvAnafClosed(): void {
        this.pvAnafControl.setValue(null);
        this.filteredPvAnaf = [...this.pvUsers];
    }

    private myCountersUserId = 0;

    loadMyCounters(): void {
        this.gestiuneService.getMyCounters().subscribe({
            next: (res: any) => {
                this.myCounters = res.data;
                this.myCountersUserId = res.data?.user_id || 0;
                this.ajutoareStats = this.mapCountersToStats(res.data);
                this.statsLastUpdated = new Date();
            },
            error: () => { this.myCounters = null; this.ajutoareStats = []; },
        });
    }

    get activeStatKey(): StatKey | null {
        if (!this.activeCounterFilter) return null;
        const stat = this.ajutoareStats.find(s => s.filterValue === this.activeCounterFilter);
        return stat?.key || null;
    }

    onStatFilterSelected(key: StatKey): void {
        const stat = this.ajutoareStats.find(s => s.key === key);
        if (stat) this.applyCounterFilter(stat.filterValue);
    }

    onResetStatsFilter(): void {
        this.activeCounterFilter = '';
        this.selectedStatusID = -1;
        this.selectedCategory = this.defaultCategory;
        this.searchParamsForm.reset(this.initialFormValues);
        this.rerenderDT();
    }

    private mapCountersToStats(c: any): StatItem[] {
        return [
            { key: 'nerepartizate', label: 'Nerepartizate', count: c.nerepartizate || 0, color: 'amber', filterValue: 'nerepartizate' },
            { key: 'verificare_docs', label: 'Verificare docs (Pas 1)', count: c.deschise_mele || 0, color: 'blue', filterValue: 'deschise' },
            { key: 'doc_aprobata', label: 'Doc. aprobată', count: c.documentatie_aprobata || 0, color: 'green', filterValue: 'documentatie_aprobata' },
            { key: 'verif_venituri', label: 'Verif. venituri', count: c.verificare_venituri_mele || 0, color: 'blue', filterValue: 'verificare_venituri' },
            { key: 'venituri_preluate', label: 'Venituri preluate', count: c.venituri_preluate_mele || 0, color: 'green', filterValue: 'venituri_preluate' },
            { key: 'in_asteptare', label: 'În așteptare', count: c.in_asteptare_mele || 0, color: 'amber', filterValue: 'in_asteptare' },
            { key: 'docs_de_verificat', label: 'Docs de verificat', count: c.verificare_documente_mele || 0, color: 'blue', filterValue: 'verificare_documente' },
        ];
    }

    applyCounterFilter(type: string): void {
        this.searchParamsForm.reset(this.initialFormValues);
        this.selectedCategory = -1; // Ignoră categoryStatus când un contor e activ
        this.activeCounterFilter = type;

        const userId = this.getCurrentUserId();

        switch (type) {
            case 'nerepartizate':
                this.selectedCategory = 3;
                this.selectedStatusID = this.getStatusIdByName('Nou');
                break;
            case 'deschise':
                this.selectedStatusID = this.getStatusIdByName('Deschis');
                this.searchParamsForm.patchValue({ pre_validare_responsabil_id: userId });
                break;
            case 'documentatie_aprobata':
                this.selectedStatusID = this.getStatusIdByName('Documentație aprobată');
                this.searchParamsForm.patchValue({ pre_validare_responsabil_id: userId });
                break;
            case 'verificare_venituri':
                this.selectedStatusID = this.getStatusIdByName('Verificare venituri');
                this.searchParamsForm.patchValue({ pre_validare_anaf_user_id: userId });
                break;
            case 'venituri_preluate':
                this.selectedStatusID = this.getStatusIdByName('Venituri preluate');
                this.searchParamsForm.patchValue({ pre_validare_responsabil_id: userId });
                break;
            case 'in_asteptare':
                this.selectedStatusID = this.getStatusIdByName('În așteptare');
                this.searchParamsForm.patchValue({ pre_validare_responsabil_id: userId });
                break;
            case 'verificare_documente':
                this.selectedStatusID = this.getStatusIdByName('Verificare documente');
                this.searchParamsForm.patchValue({ pre_validare_responsabil_id: userId });
                break;
        }
        this.rerenderDT();
    }

    private getStatusIdByName(name: string): number {
        const status = this.statusuriCerere?.find((s: any) =>
            s.name?.toLowerCase().trim() === name.toLowerCase().trim()
        );
        return status?.id || -1;
    }

    private getCurrentUserId(): number {
        return this.myCountersUserId || 0;
    }

    filterDirectii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directii.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterCompartimente(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.compartimente.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterTipCerere(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.tipCerere.filter(cerere =>
            this.normalizeString(cerere.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterDirectiiResponsabil(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiResponsabil.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterCompartimenteResponsabil(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.compartimenteResponsabil.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatori(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatori.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    // Assignment filter methods
    loadAssignmentFunctii() {
        this.isFilterLoading = true;
        this.commonService
            .getFunctii()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isFilterLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.assignmentFunctii = results;
                    this.filteredAssignmentFunctii = [...this.assignmentFunctii];
                },
                error: (error) => {
                    console.error('Error loading assignment functii', error);
                    this.filteredAssignmentFunctii = [];
                },
            });
    }

    loadAssignmentDirectii() {
        this.isFilterLoading = true;
        this.commonService
            .getDirectiiActive()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isFilterLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.assignmentDirectii = results;
                    this.filteredAssignmentDirectii = [...this.assignmentDirectii];
                },
                error: (error) => {
                    console.error('Error loading assignment directii', error);
                    this.filteredAssignmentDirectii = [];
                },
            });
    }

    loadAssignmentCompartimente(directieId?: number) {
        this.isFilterLoading = true;

        let compartimenteObservable$ = directieId
            ? this.commonService.getCompartimenteByDirectieId(directieId)
            : this.commonService.getCompartimenteActive();

        compartimenteObservable$
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            )
            .subscribe({
                next: (data) => {
                    this.assignmentCompartimente = [...data];
                    this.filteredAssignmentCompartimente = [...this.assignmentCompartimente];
                },
                error: (error) => {
                    console.error('Error loading assignment compartimente', error);
                    this.filteredAssignmentCompartimente = [];
                },
            });
    }

    loadAssignmentOperatori() {
        this.isFilterLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.searchParamsForm.controls['assignmentDirectie'].value,
            compartiment_id: this.searchParamsForm.controls['assignmentCompartiment'].value !== '-1' ? this.searchParamsForm.controls['assignmentCompartiment'].value : null
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            ).subscribe({
                next: (data) => {
                    this.assignmentOperatori = [...data];
                    this.filteredAssignmentOperatori = [...this.assignmentOperatori];
                },
                error: (error) => {
                    console.error('Error loading assignment operatori', error);
                    this.filteredAssignmentOperatori = [];
                },
            });
    }

    filterAssignmentFunctii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.assignmentFunctii.filter(functie =>
            this.normalizeString(functie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterAssignmentDirectii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.assignmentDirectii.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterAssignmentCompartimente(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.assignmentCompartimente.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterAssignmentOperatori(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.assignmentOperatori.filter(operator =>
            this.normalizeString(operator.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    loadJudete() {
        this.commonService
            .getJudeteActive()
            .pipe(
                map((results: any) => [this.filterParameter, ...results]))
            .subscribe({
                next: (results) => {
                    this.judete = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                }
            })
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    renderDT() {
        const self = this;
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, 'desc']],

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                dataTablesParameters.status = this.selectedStatusID;
                dataTablesParameters.categoryStatus = this.selectedCategory;
                dataTablesParameters.filters = {
                    ...this.searchParamsForm.value,
                    // archive: this.selectedArhivaID
                };
                dataTablesParameters.dateFilter = +this.dateFilterOption;
                dataTablesParameters.date_from = this.formatDate(
                    this.selectedStartDate
                );
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);
                dataTablesParameters.notificationParameter =
                    this.notificationParameter.id;

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.getTableRowCount();
                        this.checkboxesReset();
                        this.filterCount = resp.data.filterCount;

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });

                        if (resp.data.recordsFiltered < dataTablesParameters.start) {
                            this.rerenderDT(true);  // sets dataTablesParameters.start = 0, goes to page 1
                        }
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: '30px', targets: 0 },
                { width: '150px', targets: 1 },
            ],
            columns: [
                {
                    title: `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" id="headerCheckbox"/>`,
                    data: 'id_cerere',
                    className: 'all',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
							<div style="display: flex; align-items: center; gap: 5px;">
								<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" value="${row.id_cerere
                            }" />
							</div>
						`;
                    },
                },
                {
                    title: `Registratura / Cerere`,
                    data: 'id_cerere',
                    className: 'all',
                    render: (data: any, type: any, row: any) => {
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';


                        const sourceBadge = row.source === 'mobile'
                            ? '<span style="padding:2px 6px;background:#e3f2fd;color:#1565c0;border-radius:10px;font-size:10px;font-weight:500">Mobile</span>'
                            : row.source === 'portal-ajutoare'
                                ? '<span style="padding:2px 6px;background:#e8f5e9;color:#2e7d32;border-radius:10px;font-size:10px;font-weight:500">Portal</span>'
                                : '';
                        return `
							<div style="display: flex; align-items: center; gap: 5px;">
								<span>${row.indoc_number ? row.indoc_number : 'N/A'}</span>
								<span>/</span>
								<span>${row.created}</span>
								</div>
								<div> <br/>
									<span  style="padding: 5px; background-color: #bdbdbd; border: 0px;border-radius:5px">I: ${row.id_cerere}</span>
									${sourceBadge}
								</div>
							` + (row.mesajeInterne == 1 ?
                                `<div> <br/><span  style="padding: 4px 6px; color: white; background-color: red; border: 0px;border-radius:10px">${flagIcon} Mesaj intern</span>
									</div>`
                                : '')
                            + `
						`;
                    },
                },
                {
                    title: 'Tip Cerere',
                    data: 'subject',
                    sortable: false,

                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-addcard.svg';
                        const imageTreeUrl = '/assets/icons/icon-tree.svg';
                        return `
							<span><strong>${row.subject}</strong></span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px"> Categorie / Tip</span><br/>
							<span>
							<img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
							${row.categorie_directie} <br/>
							<img src="${imageTreeUrl}" alt="Image" style="width: 20px; height: 20px;">
							${row.categorie_compartiment}</span><br/><br/>
						`;
                    },
                },
                {
                    title: 'Identificare',
                    data: 'denumire_cetatean',
                    sortable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-user.svg';
                        return `
						<span style="color:#bdbdbd; font-size:12px"> Cetățean/Societate</span><br/>
						<img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
						<span>${row.denumire_cetatean}</span><br/> <hr/>
						${row.adresa}
						`;
                    },
                },
                {
                    title: 'Atribuire',
                    data: 'user_assigned',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-addcard.svg';
                        const imageTreeUrl = '/assets/icons/icon-tree.svg';

                        let html = `
							<span style="color:#bdbdbd; font-size:12px">Locație Solicitare</span><br/>
							<span style="color:#bdbdbd; font-size:12px">Instituție</span><br/>
							<span style="font-weight:600 font-size:16px">${row.directie}</span><br/>
							<span style="color:#bdbdbd; font-size:12px">Serviciu/Birou/Departament</span><br/>
							<span>${row.compartiment}</span><br/>
							<span style="color:#bdbdbd; font-size:12px">Operator Asignat</span><br/>
							<span>${row.user_assigned}</span>
						`;

                        // Add assignment information if available
                        if (row.has_assignments && row.assignment_summary) {
                            html += `<hr style="margin: 8px 0;" />`;
                            html += `<span style="color:#495057; font-size:12px; font-weight:600;">Asignări Cerere:</span><br/>`;
                            html += row.assignment_summary;
                        }

                        // Add document assignment information if available
                        if (row.has_document_assignments && row.document_assignment_summary) {
                            html += `<hr style="margin: 8px 0;" />`;
                            html += `<span style="color:#495057; font-size:12px; font-weight:600;">Asignări Documente:</span><br/>`;
                            html += row.document_assignment_summary;
                        }

                        return html;
                    },
                },
                {
                    title: 'Prioritate',
                    data: 'sla',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
							<span style="border-radius:10px; padding:4px 8px; white-space: nowrap; color: ${row.priority_color}; background: ${row.priority_bg_color}">${row.priority_name}</span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px">SLA</span><br/>
							<span>${row.sla}</span><br/>
						`;
                    },
                },
                {
                    title: 'Soluționare',
                    data: 'solutionare',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        // Enhanced display with multiple functions and active status
                        let html = '';

                        if (row.documente_generate && row.documente_generate.length > 0) {
                            row.documente_generate.forEach((doc: any) => {
                                if (doc.signatures && doc.signatures.length > 0) {
                                    html += '<div class="mb-2">';
                                    html += `<strong>${doc.template_name || 'Document'}</strong><br/>`;

                                    doc.signatures.forEach((sig: any) => {
                                        html += '<span class="d-inline-block me-2 mb-1">';

                                        // Function name with active indicator
                                        if (sig.use_active_function) {
                                            html += '<i class="fa-solid fa-star text-primary" title="Funcție activă"></i> ';
                                        }

                                        html += `<span class="badge badge-secondary">${sig.user_type_name || sig.functie_name}</span>`;

                                        // Show specific person if assigned
                                        if (sig.specific_user_name) {
                                            html += ` <small class="text-muted">(${sig.specific_user_name})</small>`;
                                        }

                                        // Show status
                                        if (sig.action_date) {
                                            html += ' <i class="fa-solid fa-check text-success"></i>';
                                        } else if (sig.specific_user_id) {
                                            html += ' <i class="fa-solid fa-user-check text-info"></i>';
                                        } else {
                                            html += ' <i class="fa-solid fa-clock text-warning"></i>';
                                        }

                                        html += '</span>';
                                    });

                                    html += '</div>';
                                }
                            });
                        }

                        // Fallback to original data if no enhanced info
                        if (!html && data) {
                            html = `${data}`;
                        }

                        return html || 'N/A';
                    },
                },
                {
                    title: 'Status',
                    data: 'updated_at',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        let label = '';
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';
                        if (row.validated_date && !row.cancel_date) {
                            // Validat
                            label = `<span style="border-radius:10px; padding:4px 8px; white-space: nowrap; color: white; background: green">${flagIcon}Validat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 1) {
                            // Invalidat
                            label = `<span style="border-radius:10px; padding:4px 8px; white-space: nowrap; color: white; background: orange">${flagIcon}Invalidat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 2) {
                            // Clasat
                            label = `<span style="border-radius:10px; padding:4px 8px; white-space: nowrap; color: white; background: red">${flagIcon}Clasat</span>`;
                        } else {
                            // Default case
                            label = ``;
                        }
                        return `
							<span style="border-radius:10px; padding:4px 8px; white-space: nowrap; color: ${row.status_color}; background: ${row.status_bg_color}">${row.status_name}</span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px">Ultima actualizare</span><br/>
							<span>${row.updated}</span><br/>
              				<br/>${label}
						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                // Handle click event on the CHECKBOXES
                $(row)
                    .find('.row-checkbox')
                    .off('change')
                    .on('change', function () {
                        let idCerere = Number($(this).val());

                        if ($(this).is(':checked')) {
                            self.selectedRowIds.push(idCerere);
                        } else {
                            self.selectedRowIds = self.selectedRowIds.filter(
                                (id) => id !== idCerere
                            );
                        }

                        if (self.rowCount !== self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(false);
                        } else if (self.rowCount === self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(true);
                        }

                        self.checkboxSelections = self.selectedRowIds.length > 0;
                    });

                $('td:not(:first-child):not(:nth-child(5))', row).on('click', () => {
                    this.onRowClick(data);
                });

                return row;
            },
            headerCallback: (row: Node, data: any[] | any) => {
                const headerCheckbox = $(row).find('#headerCheckbox');

                // Remove any existing event handlers to avoid duplicating them
                headerCheckbox.off('change click');

                // Handle the change event for selecting/deselecting all checkboxes
                headerCheckbox.on('change', function () {
                    if ($(this).is(':checked')) {
                        self.selectedRowIds.length = 0;
                        data.forEach((item: ICerere) => {
                            self.selectedRowIds.push(item.id_cerere);
                        });
                        self.checkMultipleCheckboxesByValue(true);
                    } else {
                        self.selectedRowIds.length = 0;
                        self.checkMultipleCheckboxesByValue(false);
                    }
                    self.checkboxSelections = self.selectedRowIds.length > 0;
                });

                // Prevent sorting when clicking the checkbox
                headerCheckbox.on('click', function (e) {
                    e.stopPropagation();
                });

                return row;
            },
        };

        // Add global function for assignment toggle functionality
        (window as any).toggleAssignments = function (assignmentListId: string) {
            const assignmentList = document.getElementById(assignmentListId);
            const icon = document.getElementById('icon_' + assignmentListId);

            if (assignmentList && icon) {
                if (assignmentList.style.display === 'none') {
                    assignmentList.style.display = 'block';
                    icon.className = 'fa fa-chevron-up';
                } else {
                    assignmentList.style.display = 'none';
                    icon.className = 'fa fa-chevron-down';
                }
            }
        };
    }

    async getTableRowCount() {
        const table = await this.dtElement.dtInstance;
        this.rowCount = table.rows().count();
    }

    checkHeaderCheckBox(checkValue: boolean) {
        const headerCheckbox = document.getElementById(
            'headerCheckbox'
        ) as HTMLInputElement;
        headerCheckbox.checked = checkValue;
    }
    checkMultipleCheckboxesByValue(checkValue: boolean) {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
        );
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checkValue;
        });
    }
    checkboxesReset() {
        this.selectedRowIds.length = 0;
        this.checkMultipleCheckboxesByValue(false);
        this.checkHeaderCheckBox(false);
        this.checkboxSelections = false;
    }

    onRowClick(rowData: ICerereListDT) {
        this.openInfoDialog(rowData);
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    openInfoDialog(data: ICerereListDT) {
        const dialogRef = this.dialog.open(CereriDetaliiComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                cerere: data,
                directii: this.directii,
                statusCerere: this.statusuriCerere,
            },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.rerenderDT();
        });
    }

    onStatusChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.activeCounterFilter = '';
        this.selectedStatusID = event.value;

        this.statusParametersValue = event.value === 'toate' ? '-1' : '1';
        this.rerenderDT();
    }

    onCategoryChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.activeCounterFilter = '';
        this.selectedCategory = event.value;

        const selectedOption = this.categoryToggleOptions.find(option => option.id === event.value);
        this.categoryParametersValue = selectedOption ? selectedOption.value : 'default';
        this.rerenderDT();
    }

    filterCategoryOptions() {
        const permissionMapping: { [key: string]: string } = {
            "-1": "dgaspc-module.cerere.list-all",
            "1": "dgaspc-module.cerere.to-approve",
            "2": "dgaspc-module.cerere.list-my-departments",
            "3": "dgaspc-module.cerere.list-my-requests",
            "4": "dgaspc-module.cerere.list-intern-messages",
        };

        // Filter categoryToggleOptions based on permissions
        this.categoryToggleOptions = this.categoryToggleOptions.filter(option =>
            this.permissionsService.hasPermission(permissionMapping[option.id.toString()])
        );

        // Initialize selectedCategory after filtering
        this.selectedCategory = this.categoryToggleOptions[0]?.id ?? -1;
        this.defaultCategory = this.selectedCategory;
    }

    onDateFilterChange(): void {
        this.rerenderDT();
    }

    openReassignComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(CereriAsigneazaComponent, {
                ...this.dialogService.getDialogConfig(),
                data: this.selectedRowIds,
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    openMassAssignVerificareVenituri() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(CereriAlocaVerificatorComponent, {
                ...this.dialogService.getDialogConfig(),
                data: this.selectedRowIds,
            });
            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    openChangeStatusComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(CereriStatusComponent, {
                ...this.dialogService.getDialogConfig(),
                data: this.selectedRowIds,
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    redirectTo(): void {
        const slug = 'someString';
        this.router.navigate([slug]);
    }

    // Assignment filter handlers
    onAssignmentFunctiiClosed() {
        const selectedValue = this.assignmentFunctiiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredAssignmentFunctii.some(functie =>
                functie.id === this.searchParamsForm.get('assignmentFunctie')?.value
            );

            if (!isSelectedInFilteredList) {
                this.assignmentFunctiiControl.setValue(null);
                this.filteredAssignmentFunctii = this.assignmentFunctii;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onAssignmentFunctiiChange(functieId: number): void {
        // No cascading effect for functie selection, independent filter
    }

    onAssignmentDirectiiClosed() {
        const selectedValue = this.assignmentDirectiiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredAssignmentDirectii.some(directie =>
                directie.id === this.searchParamsForm.get('assignmentDirectie')?.value
            );

            if (!isSelectedInFilteredList) {
                this.assignmentDirectiiControl.setValue(null);
                this.filteredAssignmentDirectii = this.assignmentDirectii;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onAssignmentDirectiiChange(directieId: number): void {
        this.searchParamsForm.controls['assignmentCompartiment'].patchValue('-1');
        this.searchParamsForm.controls['assignmentOperator'].patchValue('');

        if (directieId > 0) {
            this.loadAssignmentCompartimente(directieId);
            this.loadAssignmentOperatori();
        } else {
            this.assignmentCompartimente = [];
            this.assignmentOperatori = [];
            this.filteredAssignmentCompartimente = [];
            this.filteredAssignmentOperatori = [];
        }
    }

    onAssignmentCompartimenteClosed() {
        const selectedValue = this.assignmentCompartimenteControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredAssignmentCompartimente.some(compartiment =>
                compartiment.id === this.searchParamsForm.get('assignmentCompartiment')?.value
            );

            if (!isSelectedInFilteredList) {
                this.assignmentCompartimenteControl.setValue(null);
                this.filteredAssignmentCompartimente = this.assignmentCompartimente;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onAssignmentCompartimenteChange(compartimentId: number): void {
        this.searchParamsForm.controls['assignmentOperator'].patchValue('');

        if (compartimentId) {
            this.loadAssignmentOperatori();
        } else {
            this.assignmentOperatori = [];
            this.filteredAssignmentOperatori = [];
        }
    }

    onAssignmentOperatorClosed() {
        const selectedValue = this.assignmentOperatoriControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredAssignmentOperatori.some(operator =>
                operator.id === this.searchParamsForm.get('assignmentOperator')?.value
            );

            if (!isSelectedInFilteredList) {
                this.assignmentOperatoriControl.setValue(null);
                this.filteredAssignmentOperatori = this.assignmentOperatori;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onFiltreChange(event: MatButtonToggleChange) {
        this.selectedFiltre = event.value;
    }
}
